<div class="container">
  <app-header></app-header>
  <main>
    <router-outlet></router-outlet>
  </main>
  <div class="footer">
  <app-footer></app-footer>
  </div>
</div>
